import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FileText, UploadCloud, Download } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BrochureManager = ({ token }) => {
  const [info, setInfo] = useState(null);
  const [uploading, setUploading] = useState(false);

  const load = async () => {
    const { data } = await axios.get(`${API}/brochure/info`);
    setInfo(data);
  };

  useEffect(() => { load(); }, []);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.name.toLowerCase().endsWith(".pdf")) {
      toast.error("Sirf PDF file upload karein");
      return;
    }
    if (file.size > 30 * 1024 * 1024) {
      toast.error("Brochure 30 MB se chhota hona chahiye");
      return;
    }
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      await axios.post(`${API}/admin/brochure`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Brochure upload ho gaya");
      load();
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div data-testid="brochure-manager" className="max-w-xl bg-white border border-[#221533]/10 rounded-2xl p-7">
      <h2 className="font-clash text-2xl font-medium text-[#221533] mb-1">Product Brochure</h2>
      <p className="text-sm text-[#221533]/55 mb-6">
        Website ke "Brochure" tab se customers yahi PDF download karenge.
      </p>

      {info?.available ? (
        <div data-testid="brochure-current" className="flex items-center gap-3 bg-[#FAF8FC] border border-[#8E5A9E]/25 rounded-xl px-4 py-3.5 mb-6">
          <FileText size={20} className="text-[#8E5A9E] shrink-0" />
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold text-[#221533] truncate">{info.filename}</p>
            <p className="text-xs text-[#221533]/45">
              {(info.size / (1024 * 1024)).toFixed(1)} MB · {info.uploaded_at?.slice(0, 10)}
            </p>
          </div>
          <a
            data-testid="brochure-download-link"
            href={`${API}/brochure`}
            className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#74427F] hover:text-[#8E5A9E] transition-colors"
          >
            <Download size={14} /> Download
          </a>
        </div>
      ) : (
        <p data-testid="brochure-empty" className="text-sm text-[#221533]/45 mb-6">Abhi koi brochure upload nahi hua hai.</p>
      )}

      <label
        data-testid="brochure-upload-label"
        className={`flex flex-col items-center justify-center gap-2 border-2 border-dashed border-[#8E5A9E]/35 hover:border-[#8E5A9E] rounded-xl px-6 py-9 cursor-pointer transition-colors ${uploading ? "opacity-50 pointer-events-none" : ""}`}
      >
        <UploadCloud size={26} className="text-[#8E5A9E]" />
        <span className="text-sm font-semibold text-[#74427F]">
          {uploading ? "Uploading…" : info?.available ? "Naya brochure upload karein (replace hoga)" : "Brochure PDF upload karein"}
        </span>
        <span className="text-xs text-[#221533]/40">PDF, max 30 MB</span>
        <input data-testid="brochure-file-input" type="file" accept="application/pdf,.pdf" className="hidden" onChange={onFile} />
      </label>
    </div>
  );
};
